import { typeBuilder } from 'base/shared/TypeHelper';

export default typeBuilder(['RESET_NOTIFICATIONS', 'SET_NOTIFICATIONS']);
